import React, { Component } from 'react';
import { inject } from 'mobx-react';

import DataSelectForm from './DataSelectForm';

import { FormStore } from 'core/forms/FormStore';

import { values, funcs } from './dataSelectFormData';

import './dataSelect.scss';

const formStore = new FormStore(values, funcs);

@inject('dataSelectStore')
@inject('orderStore')
class DataSelect extends Component {
  handleFormSubmit = (values) => {
    this.props.orderStore.loadData(values).then((res) => {
      if (res && res.viewType) {
        // a cleaner approach would be use something from "res" instead of "values.datatype" to keep the logic as dynamic as possible, but
        //  the way it is should be fine for now as well
        this.props.history.push(`/data-viewing/${values.datatype || ''}`, values);
      }
      return res;
    });
  };

  componentWillMount() {
    this.props.dataSelectStore.clearSelectData();
  }

  render() {
    return (
      <div className="data-select-page">
        <div className="page-body">
          <DataSelectForm onSubmit={this.handleFormSubmit} formStore={formStore} />
        </div>
      </div>
    );
  }
}

export default DataSelect;



// WEBPACK FOOTER //
// ./src/containers/DataSelect/DataSelect.jsx